import { useAuth } from "../AppContext"
import {
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER,
     CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED,
     CONST_USER_ROLE_COMPTABLE,
     CONST_USER_ROLE_DAF,
     CONST_USER_ROLE_RESPONSABLE_RH,
     CONST_USER_ROLE_RH,
} from "@common-constants/*"

const useUser = () => {
     const { currentUser } = useAuth()
     const permissions = currentUser?.permissions ?? []

     const isFullStaff = permissions.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW)
     const isRestrictedStaff = permissions.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED)
     const isManagerStaff = permissions.includes(CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER)

     function isAdministratif(): boolean {
          return !!(
               currentUser?.roles?.includes(CONST_USER_ROLE_RH) ||
               currentUser?.roles?.includes(CONST_USER_ROLE_RESPONSABLE_RH) ||
               currentUser?.roles?.includes(CONST_USER_ROLE_COMPTABLE) ||
               currentUser?.roles?.includes(CONST_USER_ROLE_DAF)
          )
     }

     // Gestion staff COMPLÈTE : actions sensibles, édition de tous les champs, permissions, onglet Paramètres du compte.
     function hasFullStaffManagement(): boolean {
          return isFullStaff
     }

     // Accès à la gestion staff en consultation (complet, restreint OU manager métier).
     function canViewStaff(): boolean {
          return isFullStaff || isRestrictedStaff || isManagerStaff
     }

     // Gérer le container Teamwork recrutement : complet OU manager.
     function canManageStaffTeamwork(): boolean {
          return isFullStaff || isManagerStaff
     }

     // Onglet Carte NFC : accès complet uniquement (ni restreint, ni manager métier).
     function canManageStaffNfc(): boolean {
          return isFullStaff
     }

     // Documents administratifs (pièces du collaborateur / fournisseur) : complet OU restreint (pas le manager).
     function canManageStaffAdministrativeDocuments(): boolean {
          return isFullStaff || isRestrictedStaff
     }

     // Éditer les informations PROFESSIONNELLES : complet OU restreint (le manager est en lecture seule sur le pro).
     function canEditStaffInfos(): boolean {
          return isFullStaff || isRestrictedStaff
     }

     // Éditer les informations PERSONNELLES : complet, restreint OU manager métier.
     function canEditStaffInfosPerso(): boolean {
          return isFullStaff || isRestrictedStaff || isManagerStaff
     }

     // Voir les infos perso sensibles (email, tél, n° sécu, résidence, contact urgence) : complet, restreint OU manager.
     function canSeeStaffSensitivePersoInfos(): boolean {
          return isFullStaff || isRestrictedStaff || isManagerStaff
     }

     // Voir le n° immat. CEGEDIM & le code analytique : complet OU restreint uniquement (pas le manager).
     function canSeeStaffCegedimAnalytique(): boolean {
          return isFullStaff || isRestrictedStaff
     }

     // Éditer le n° immat. CEGEDIM & le code analytique : complet OU restreint.
     function canEditStaffCegedimAnalytique(): boolean {
          return isFullStaff || isRestrictedStaff
     }

     return {
          isAdministratif,
          hasFullStaffManagement,
          canViewStaff,
          canManageStaffTeamwork,
          canManageStaffNfc,
          canManageStaffAdministrativeDocuments,
          canEditStaffInfos,
          canEditStaffInfosPerso,
          canSeeStaffSensitivePersoInfos,
          canSeeStaffCegedimAnalytique,
          canEditStaffCegedimAnalytique,
     }
}

export default useUser
